/* eslint-disable no-param-reassign */
import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { getApi } from 'lib/axios';
import { GET_COLORS_API } from 'utils/apiConstants';
import { USER_BASE_URL } from 'utils/const';

export const fetchColor = createAsyncThunk('color/fetchColor', async (id) => {
  const res = await getApi(`${USER_BASE_URL}${GET_COLORS_API}?maker_id=${id}`);

  return {
    data: res.data,
  };
});

const colorAdapter = createEntityAdapter();

const colorSlice = createSlice({
  name: 'color',
  initialState: colorAdapter.getInitialState({
    loading: true,
  }),
  reducers: {
    addTag: colorAdapter.addOne,
    removeAll: colorAdapter.removeAll,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchColor.fulfilled, (state, action) => {
      state.loading = false;
      colorAdapter.setAll(state, action.payload.data);
    });
  },
});

export const { removeAll: resetColor } = colorSlice.actions;

export const colorSelector = colorAdapter.getSelectors((state) => state.color);

export default colorSlice.reducer;
